import { AfterViewInit, Component, DestroyRef, ElementRef, HostListener, Input, OnChanges, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';
import { Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LayoutService } from '@shared/services/layout.service';

@Component({
  selector: 'app-header-v1',
  templateUrl: './header-v1.component.html',
  styleUrls: ['./header-v1.component.scss']
})
export class HeaderV1Component implements OnInit, OnChanges, OnDestroy {
  @ViewChild('menu', { static: false }) menuRef!: ElementRef;
  isClicked: boolean = false;
  @Input() presentComponent: number = 0;
  activeColor: boolean = false;
  activeMenu: string = '';
  toggleMenu: boolean = false;
  isSmallScreen: boolean = false;
  activeClass: boolean = false;

  private destroyRef = inject(DestroyRef);

  constructor(
    private readonly router: Router,
    private readonly layoutService: LayoutService
  ) { }

  ngOnInit(): void {
    this.layoutService.isSmallScreen$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((isSmall: boolean) => {
      this.isSmallScreen = isSmall;
      this.toggleMenu = !isSmall;
    });
  }

  ngOnChanges(): void {
    if (this.isSmallScreen) {
      this.toggleMenu = false;
    }
  }

  ngOnDestroy(): void {
    // Cleanup handled by takeUntilDestroyed
  }

  clickMenu(event: Event) {
    event.stopPropagation();
    this.isClicked = !this.isClicked;
  }

  @HostListener('document:click', ['$event'])

  onDocumentClick(event: Event) {

    const clickedInside = this.menuRef?.nativeElement?.contains(event.target);
    if (!clickedInside) {
      this.isClicked = false;
    }
  };

  isRouteActive(): boolean {
    return this.router.url === '/truck-driver' || this.router.url === '/group-operator';
  };
  closeMenu() {
    this.toggleMenu = false;
  }
  openMenu() {
    this.toggleMenu = true;
  }
  redirectToServices() {
    this.activeClass = true;
    this.router.navigate(['/truck-driver']).then(() => {
      setTimeout(() => {
        const target = document.getElementById('community-sec');
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 200);
    });
  }
}
